import { render, staticRenderFns } from "./AdditionalInputDiscount.vue?vue&type=template&id=da15741e"
import script from "./AdditionalInputDiscount.vue?vue&type=script&lang=js"
export * from "./AdditionalInputDiscount.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInputDiscount.vue?vue&type=style&index=0&id=da15741e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports